import {
  AUTH_ID,
  AUTH_USER,
  IS_AUTHENTICATED,
  USER_COUNTRY,
  WAIT_DAYS,
  RETURN_AFTER_DAY,
  NEEDS_TO_UPDATE_PAYMENT_METHOD,
  GET_ADDITIONAL_PAYMENT_DATA
} from '@/utils/store/getterTypes'
import { logError } from '@/utils/general'

export default {
  /**
   * ID of the current authenticated user
   *
   * @param state
   * @returns {*}
   */
  [AUTH_ID] (state) {
    return state.user?.user?._id
  },

  /**
   * Current authenticated user
   *
   * @param state
   * @returns {*}
   */
  [AUTH_USER] (state) {
    return state.user
  },

  /**
   * Currently authenticated or not
   *
   * @param state
   * @returns {boolean}
   */
  [IS_AUTHENTICATED] (state) {
    return state.loggedIn
  },

  /**
   * Returns true if the customer needs to update his payment method
   *
   * @param state
   * @return {boolean}
   */
  [NEEDS_TO_UPDATE_PAYMENT_METHOD] (state) {
    if (!state.user) {
      return false
    }

    try {
      const hasPaymentMethod = state.user.user.paymentContracts.edges.some(payment => payment.node.active)

      return !hasPaymentMethod
    } catch (e) {
      logError(e)
      return false
    }
  },

  /**
   * The user's country
   *
   * @param state
   * @returns {string}
   */
  [USER_COUNTRY] (state) {
    const country = state.user?.user.country.name.toLowerCase()

    return country
  },

  /**
   * Checks if a user can do a return order
   *
   * @param state
   * @returns {int}
   */
  [WAIT_DAYS] (state) {
    return state.user?.user.country.expectedDeliveryDateDailyOrderAfterDays
  },

  /**
   * Checks if a user can do a return order
   *
   * @param state
   * @returns {int}
   */
  [RETURN_AFTER_DAY] (state) {
    return state.user.user.country.canDoReturnRequestAfterDay
  },
  [GET_ADDITIONAL_PAYMENT_DATA] (state) {
    return {
      givenName: state.user?.user.firstName,
      surname: state.user?.user.lastName,
      ipAddress: state.ipAddress,
      userCountry: state.user?.user.country.name.toLowerCase(),
      email: state.user?.user.email
    }
  }
}
